import {
  type RouteRecordRaw,
} from 'vue-router'
import DefaultLayout from '@/layout/default/index.vue'
import { findFirstRouteWithPermission } from '../utils'

const CapitalRoutes: RouteRecordRaw[] = [
  {
    name: 'Capital',
    path: '/capital',
    redirect: () => {
      return findFirstRouteWithPermission(CapitalRoutes[0].children ?? [])
    },
    meta: {
      title: '资金中心',
      order: 1,
    },
    component: DefaultLayout,
    children: [
      // {
      //   path: 'index',
      //   name: 'CapitalIndex',
      //   component: () => import('@/views/empty.vue'),
      //   meta: {
      //     title: '资金总览',
      //     isTopLevel: true,
      //     icon: 'icon-zonglan',
      //   },
      // },
      {
        path: 'withdrawMgt',
        name: 'WithdrawMgt',
        meta: {
          title: '提现管理',
          icon: 'icon-currency-yen',
        },
        redirect: { name: 'WithdrawMgtHome' },
        children: [
          {
            path: 'home',
            name: 'WithdrawMgtHome',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '提现',
              devUrl: 'http://localhost:8008/withdraw/home',
              url: `${window.location.origin}/merchant-platform/micro-funds/withdraw/home`,
              permission: ['WITHDRAW'],
            },
          },
          {
            path: 'record',
            name: 'WithdrawMgtRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '提现记录',
              devUrl: 'http://localhost:8008/withdraw/record',
              url: `${window.location.origin}/merchant-platform/micro-funds/withdraw/record`,
              permission: ['WITHDRAW_RECORD'],
            },
          },
        ],
      },
      {
        path: 'separateAccounts',
        name: 'CapitalSeparateAccounts',
        meta: {
          title: '分账管理',
          icon: 'icon-currency-yen',
        },
        redirect: { name: 'CapitalSeparateAccountsBatch' },
        children: [
          {
            path: 'batch',
            name: 'CapitalSeparateAccountsBatch',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '发起分账',
              devUrl: 'http://localhost:8008/split-bill-management/split-bill',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/split-bill`,
              permission: ['SHARING_APPLY', 'BALANCE_SHARING_APPLY'],
            },
          },
          {
            path: 'batchRecord',
            name: 'CapitalSeparateAccountsBatchRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '批量分账查询',
              devUrl: 'http://localhost:8008/split-bill-management/split-bill-query',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/split-bill-query`,
              permission: ['SHARING_ORDER_QUERY'],
            },
          },
          {
            path: 'batchRecordQuery',
            name: 'CapitalSeparateAccountsBatchRecordQuery',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '批量分账明细查询',
              devUrl: 'http://localhost:8008/split-bill-management/split-bill-detail-query',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/split-bill-detail-query`,
              permission: ['BATCH_SHARING_DETAIL_QUERY'],
            },
          },
          {
            path: 'order-split-bill-query',
            name: 'CapitalSeparateAccountsOrderSplitBillQuery',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '订单分账记录查询',
              devUrl: 'http://localhost:8008/split-bill-management/order-split-bill-query',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/order-split-bill-query`,
              permission: ['TRADE_SHARING_QUERY'],
            },
          },
          {
            path: 'balanceRecord',
            name: 'CapitalSeparateAccountsBalanceRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '余额分账查询',
              devUrl: 'http://localhost:8008/split-bill-management/balance-query',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/balance-query`,
              permission: ['BALANCE_SHARING_QUERY'],
            },
          },
          {
            path: 'balanceDetailRecord',
            name: 'CapitalSeparateAccountsBalanceDetailRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '余额分账明细查询',
              devUrl: 'http://localhost:8008/split-bill-management/balance-query-details',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/balance-query-details`,
              permission: ['BALANCE_SHARING_QUERY'],
            },
          },
          {
            path: 'auto',
            name: 'CapitalSeparateAccountsAuto',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '自动分账查询',
              devUrl: 'http://localhost:8008/split-bill-management/auto-split-bill-query',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/auto-split-bill-query`,
              permission: ['SHARING_AUTO_QUERY'],
            },
          },
          {
            path: 'split-bill-receiver-management',
            name: 'CapitalSeparateAccountsSplitBillReceiverManagement',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '分账收款方管理',
              devUrl: 'http://localhost:8008/split-bill-management/split-bill-receiver-management',
              url: `${window.location.origin}/merchant-platform/micro-funds/split-bill-management/split-bill-receiver-management`,
              permission: ['SHARING_PAYEE_QUERY'],
            },
          }],
      }, {
        path: 'payment',
        name: 'CapitalPayment',
        meta: {
          title: '付款到银行卡管理',
          icon: 'icon-bank-card',
        },
        children: [{
          path: 'bank',
          name: 'CapitalPaymentBank',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '付款到银行卡账户',
            devUrl: 'http://localhost:8008/transfer-bank/home',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/home`,
            permission: ['TRANSFER_TO_BANK'],
          },
        },
        {
          path: 'payee-manage',
          name: 'CapitalPaymentBankPayeeManage',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '收款方管理',
            devUrl: 'http://localhost:8008/transfer-bank/payee-manage',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/payee-manage`,
            permission: ['PAY_BANK_PAYEE_QUERY'],
          },
        },
        {
          path: 'quick-recharge',
          name: 'CapitalPaymentBankQuickRecharge',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '快捷充值',
            devUrl: 'http://localhost:8008/transfer-bank/quick-recharge',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/quick-recharge`,
            permission: ['GUARANTEED_RECHARGE'],
          },
        },
        {
          path: 'singleBatch',
          name: 'CapitalPaymentBankSingleBatch',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '单笔付款记录',
            devUrl: 'http://localhost:8008/transfer-bank/record',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/record`,
            permission: ['TRANSFER_TO_BANK_RECORD'],
          },
        },
        {
          path: 'batch',
          name: 'CapitalPaymentBankBatch',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '批量付款记录',
            devUrl: 'http://localhost:8008/transfer-bank/record-batch',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/record-batch`,
            permission: ['TRANSFER_TO_BANK_RECORD'],
          },
        },
        {
          path: 'detail-batch',
          name: 'CapitalPaymentBankDetailBatch',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '批量付款明细查询',
            devUrl: 'http://localhost:8008/transfer-bank/detail-batch',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/detail-batch`,
            permission: ['TRANSFER_TO_BANK_RECORD'],
          },
        },
        {
          path: 'record',
          name: 'CapitalPaymentBankRecord',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '付款凭证下载',
            devUrl: 'http://localhost:8008/transfer-bank/voucher-download',
            url: `${window.location.origin}/merchant-platform/micro-funds/transfer-bank/voucher-download`,
            permission: ['TTB_CERT_DOWNLOAD'],
          },
        },

        ],
      },
      {
        path: 'paymentSP',
        name: 'CapitalPaymentSP',
        meta: {
          title: '付款到盛付通账户',
          icon: 'icon-bank-card',
        },
        redirect: { name: 'CapitalPaymentSPPayee' },
        children: [
          {
            path: 'payee',
            name: 'CapitalPaymentSPPayee',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '收款方管理',
              devUrl: 'http://localhost:8008/payment/payee',
              url: `${window.location.origin}/merchant-platform/micro-funds/payment/payee`,
              permission: ['TRANSFER_PAYEE_QUERY'],
            },
          },
          {
            path: 'transfer',
            name: 'CapitalPaymentSPTransfer',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '转账到盛付通账户',
              devUrl: 'http://localhost:8008/transfer-shengpay/home',
              url: `${window.location.origin}/merchant-platform/micro-funds/transfer-shengpay/home`,
              permission: ['TRANSFER_TO_ACCOUNT'],
            },
          },
          {
            path: 'record',
            name: 'CapitalPaymentSPTransferRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '单笔转账记录',
              devUrl: 'http://localhost:8008/transfer-shengpay/record',
              url: `${window.location.origin}/merchant-platform/micro-funds/transfer-shengpay/record`,
              permission: ['TRANSFER_TO_ACCOUNT_RECORD'],
            },
          },
          {
            path: 'batchRecord',
            name: 'CapitalPaymentSPTransferBatchRecord',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '批量转账记录',
              devUrl: 'http://localhost:8008/transfer-shengpay/record-batch',
              url: `${window.location.origin}/merchant-platform/micro-funds/transfer-shengpay/record-batch`,
              permission: ['TRANSFER_TO_ACCOUNT_RECORD'],
            },
          },
          {
            path: 'batchDetail',
            name: 'CapitalPaymentSPTransferBatchDetail',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '批量转账明细查询',
              devUrl: 'http://localhost:8008/transfer-shengpay/detail-batch',
              url: `${window.location.origin}/merchant-platform/micro-funds/transfer-shengpay/detail-batch`,
              permission: ['TRANSFER_TO_ACCOUNT_RECORD'],
            },
          },
          {
            path: 'recordTotal',
            name: 'CapitalPaymentSPTransferRecordTotal',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '付款凭证下载',
              devUrl: 'http://localhost:8008/transfer-shengpay/record-total',
              url: `${window.location.origin}/merchant-platform/micro-funds/transfer-shengpay/record-total`,
              permission: ['TTA_CERT_DOWNLOAD'],
            },
          },
        ],
      },
      {
        path: 'recharge',
        name: 'Recharge',
        meta: {
          title: '充值管理',
          icon: 'icon-database',
        },
        children: [{
          path: 'index',
          name: 'RechargeIndex',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '充值',
            devUrl: 'http://localhost:8008/recharge/index',
            url: `${window.location.origin}/merchant-platform/micro-funds/recharge/index`,
            permission: ['DEPOSIT', 'OFFLINE_CHARGE'],
          },
        }, {
          path: 'record',
          name: 'RechargeRecord',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '充值记录',
            devUrl: 'http://localhost:8008/recharge/record',
            url: `${window.location.origin}/merchant-platform/micro-funds/recharge/record`,
            permission: ['DEPOSIT_RECORD', 'OFFINE_DEPOSIT_RECORD_QUERY', 'DEPOSIT_QUICK_PAY_RECORD'],
          },
        }],
      },
      {
        path: 'unionPayroll',
        name: 'UnionPayroll',
        meta: {
          title: '联合发薪',
          icon: 'icon-currency-yen',
        },
        children: [{
          path: 'index',
          name: 'UnionPayrollIndex',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '订单管理',
            devUrl: 'http://localhost:8008/order-management/home',
            url: `${window.location.origin}/merchant-platform/micro-funds/order-management/home`,
            permission: ['UNION_SALARY_ORDER_QUERY', 'UNION_SALARY_ORDER_DOWNLOAD'],
          },
        }],
      },
      // {
      //   path: 'withdrawal',
      //   name: 'Withdrawal',
      //   meta: {
      //     title: '提现管理',
      //     icon: 'icon-fenzhang',
      //   },
      //   children: [{
      //     path: 'index',
      //     name: 'WithdrawalIndex',
      //     meta: {
      //       title: '提现',
      //       link: `${window.location.origin}/user.html#/withdraw/home`,
      //     },
      //   }, {
      //     path: 'record',
      //     name: 'WithdrawalRecord',
      //     meta: {
      //       title: '提现记录',
      //       link: `${window.location.origin}/user.html#/withdraw/log`,
      //     },
      //   }],
      // },
      {
        path: 'financialService',
        name: 'FinancialService',
        meta: {
          title: '金融服务',
          icon: 'icon-jinrong',
        },
        children: [
          {
            path: 'syb',
            name: 'FinancialServiceSYB',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '盛意宝',
              devUrl: 'http://localhost:8008/financial-service/syb',
              url: `${window.location.origin}/merchant-platform/micro-funds/financial-service/syb`,
              permission: ['MONEY_MGR_IN', 'MONEY_MGR_OUT'],
            },
          },
          {
            path: 'wallet',
            name: 'FinancialServiceWallet',
            component: () => import('@/views/wujie.vue'),
            meta: {
              title: '聚合钱包',
              devUrl: 'http://localhost:8008/financial-service/wallet',
              url: `${window.location.origin}/merchant-platform/micro-funds/financial-service/wallet`,
              permission: ['FUND_COLLECTION'],
            },
          },
          // {
          //   path: 'jsh',
          //   name: 'FinancialServiceJSH',
          //   meta: {
          //     title: '结收汇(未提供)',
          //   },
          // },
          // {
          //   path: 'gfh',
          //   name: 'FinancialServiceGFH',
          //   meta: {
          //     title: '购付汇(未提供)',
          //   },
          // },
        ],
      },
      {
        path: 'orderPay',
        name: 'OrderPay',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '订单支付',
          devUrl: 'http://localhost:8008/order-payment/create',
          url: `${window.location.origin}/merchant-platform/micro-funds/order-payment/create`,
          isTopLevel: true,
          icon: 'icon-fenzhang',
          permission: ['UNION_ORDER_PAY'],
        },
      },
      {
        path: 'shiftSettle',
        name: 'ShiftSettle',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '交班记录',
          devUrl: 'http://localhost:8008/shift-settle/record',
          url: `${window.location.origin}/merchant-platform/micro-funds/shift-settle/record`,
          icon: 'icon-document-text',
          isTopLevel: true,
          permission: ['MCH_FUND_HANDOVER_QUERY'],
        },
      },
    ],
  },
] as Array<RouteRecordRaw>
export default CapitalRoutes
